import { BookOpenTextIcon } from 'lucide-react'
import { type ComponentPropsWithoutRef, forwardRef, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface PromptTemplateTriggerProps
  extends Omit<ComponentPropsWithoutRef<'button'>, 'disabled'> {
  isDisabled?: boolean
}

/**
 * Trigger button for the prompt template popover.
 */
export const PromptTemplateTrigger = forwardRef<HTMLButtonElement, PromptTemplateTriggerProps>(
  ({ isDisabled = false, className, ...rest }, ref): ReactNode => (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      size="sm"
      disabled={isDisabled}
      className={cn('chat-input-templates-button gap-1.5', className)}
      aria-label="Prompt templates"
      {...rest}
    >
      <BookOpenTextIcon className="size-4" />
      <span className="hidden sm:inline">Templates</span>
    </Button>
  )
)

PromptTemplateTrigger.displayName = 'PromptTemplateTrigger'
